/* eslint-disable max-len */
const resultTitle = "Результат";

const data = {
    title: "Лига Шампиньонов",
    // subtitle:
    //     "<p>Добро пожаловать в&nbsp;Лигу Шампиньонов! Зарабатывай очки и приведи команду к&nbsp;победе!</p> <p><span>Турнир завершится 16&nbsp;апреля 2025&nbsp;года</span></p>",
    subtitle:
        "<p><span>Команда Канониры&nbsp;&mdash; чемпион!</span></p><p>Турнир завершён, это было легендарно. Спасибо за&nbsp;участие! Кстати, игра по-прежнему доступна</p>",
    startLabel: "Играть",
    info: "Информация",
    pageScreens: [
        {
            label: "Вступление и правила",
            text: "<p>Собирай футбольные мячи и&nbsp;избегай Шампиньонов из&nbsp;команд-соперников, они будут мешать тебе набрать очки и&nbsp;победить</p>",
            nextLabel: "Играть",
        },
    ],
    ratingsTitle: "Рейтинг",
    resultTitle: "Результат",
    resultRatingsTitle: "Рейтинг команд",
    restartLabel: "Играть",
    championatLink: "https://championat.com/",
    betcityText: "Бетсити",
    betcityLink:
        "https://promote.betcity.ru/champions_league_2000/?widget_id=freebet2000_ligashampinion&refcode=ligashampinion_logo&icm=2612&utm_source=2612&utm_medium=cpm&utm_campaign=freebet2000_ligashampinion_logo&utm_content=logo_ligashampinion",
    claimBonusLabel: "Получить бонус",
    claimBonusLinkRatings:
        "https://promote.betcity.ru/champions_league_2000/?widget_id=freebet2000_ligashampinion&refcode=ligashampinion_button_rating&icm=2612&utm_source=2612&utm_medium=cpm&utm_campaign=freebet2000_ligashampinion_button_rating&utm_content=button_rating_ligashampinion",
    claimBonusLinkResults:
        "https://promote.betcity.ru/champions_league_2000/?widget_id=freebet2000_ligashampinion&refcode=ligashampinion_button_result&icm=2612&utm_source=2612&utm_medium=cpm&utm_campaign=freebet2000_ligashampinion_button_result&utm_content=button_result_ligashampinion",
    shareCTA: "Поделиться",
    shareLabel: "Поделиться в ",
    noScript:
        "Чтобы поиграть в &laquo;Змейку&raquo; и собрать желанные подарки, нужно подключить поддержку JavaScript",
    presentLink:
        "https://promote.betcity.ru/champions_league_2000/?widget_id=freebet2000_ligashampinion&refcode=ligashampinion_gift&icm=2612&utm_source=2612&utm_medium=cpm&utm_campaign=freebet2000_ligashampinion_gift&utm_content=gift_ligashampinion",
    giftText: "Подарок от&nbsp;БЕТСИТИ",
    giftLabel: "Подарок от БЕТСИТИ",
    legalText:
        "Реклама.18+. ООО«Фортуна». ИНН:6164205110. erid:&nbsp;2Ranynxfw7F",
    teams: [
        {
            id: "parizhane",
            name: "Парижане",
        },
        {
            id: "trenerishka-team",
            name: "Тренеришка Team",
        },
        {
            id: "kanoniri",
            name: "Канониры",
        },
        {
            id: "galaktikos",
            name: "Галактикос",
        },
        {
            id: "blaugrana",
            name: "Блауграна",
        },
        {
            id: "shmeli",
            name: "Шмели",
        },
        {
            id: "fk-gollivud",
            name: "ФК Голливуд",
        },
        {
            id: "zmei",
            name: "Змеи",
        },
    ],
    results: {
        best: {
            check: (score) => score >= 30,
            title: resultTitle,
            text: "Да, ты настоящий чемпион! <br/>Ты принесешь победу команде!",
            // shareImageKey: 'ResultBackgroundBest'
        },
        good: {
            check: (score) => score < 30 && score >= 20,
            title: resultTitle,
            text: "Да, ты настоящий чемпион! <br/>Ты принесешь победу команде!",
            // shareImageKey: 'ResultBackgroundGood'
        },
        notBad: {
            check: (score) => score < 20 && score >= 10,
            title: resultTitle,
            text: "Да, ты настоящий чемпион! <br/>Ты принесешь победу команде!",
            // shareImageKey: 'ResultBackgroundNotBad'
        },
        worst: {
            check: (score) => score < 10,
            title: resultTitle,
            text: "Да, ты настоящий чемпион! <br/>Ты принесешь победу команде!",
            // shareImageKey: 'ResultBackgroundWorst'
        },
    },
    authors: {
        title: "Команда проекта:",
        items: [
            {
                items: [
                    {
                        role: "Руководитель группы реализации проектов",
                        names: ["Елена Киселева"],
                    },
                    {
                        role: "Менеджер по работе с&nbsp;клиентом &laquo;СберСеллер&raquo;",
                        names: ["Павел Казаков"],
                    },
                    {
                        role: "Руководитель проекта",
                        names: ["Евгения Тихонова"],
                    },
                    {
                        role: "Менеджер продукта",
                        names: ["Анна Болдырева"],
                    },
                    {
                        role: "Автор идеи",
                        names: ["Екатерина Щилова"],
                    },
                    {
                        role: "Автор текстов",
                        names: ["Иван Бровар"],
                    },
                    {
                        role: "Руководитель интернет-маркетинга БЕТСИТИ",
                        names: ["Анна Денисенко"],
                    },
                    {
                        role: "Менеджер БЕТСИТИ",
                        names: ["Салим Бутерфас"],
                    },
                ],
            },
            {
                type: "secondary",
                title: "VisCom by Rambler&Co:",
                items: [
                    {
                        role: "Директор по визуальным коммуникациям",
                        names: ["Николай Чернов"],
                    },
                    {
                        role: "Арт-директор",
                        names: ["Ирина Чернова"],
                    },
                    {
                        role: "Продюсер",
                        names: ["Дарья Романова"],
                    },
                    {
                        role: "Разработка",
                        names: ["Никита Гречишников", "Наталья Габитова"],
                    },
                ],
            },
        ],
    },
};

module.exports = data;
